import { createWithEqualityFn } from 'zustand/traditional';
import { NestedSpeculator } from '@habity/types';

export interface SpeculatorMatchSelectionProps {
  speculatorsSelection: NestedSpeculator[];
}

export interface BuyerMatchSelectionState extends SpeculatorMatchSelectionProps {
  setSpeculatorsSelection: (buyers: NestedSpeculator[]) => void;
  toggleSpeculatorSelection: (buyer: NestedSpeculator) => void;
}

const DEFAULT_PROPS: SpeculatorMatchSelectionProps = {
  speculatorsSelection: [],
};

export const useSpeculatorSelectionStore = createWithEqualityFn<BuyerMatchSelectionState>()((set, get) => ({
  ...DEFAULT_PROPS,
  setSpeculatorsSelection: (speculatorsSelection) => set({ speculatorsSelection }),
  toggleSpeculatorSelection: (speculatorToToggle) => {
    const selected = get().speculatorsSelection;

    if (selected.map((item) => item.id).includes(speculatorToToggle.id)) {
      set({
        speculatorsSelection: selected.filter((item) => item.id !== speculatorToToggle.id)
      })
    } else {
      set({ speculatorsSelection: [...selected, speculatorToToggle] })
    }
  },
}));
